import { apiBaseAssets, apiBaseUrl } from "../config/api";
import { useEffect, useState, useContext, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import axios from "axios";
import { AuthContext } from "../context/auth-context";
import { Navigation } from "./navigation";
import lc from "../utils/language";
export const More = ({ data }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [more, setMore] = useState(false);
  const authContext = useContext(AuthContext);
  const quillRef = useRef();
  const isRtl = authContext.currentLanguage === "AR" ? true : false;
  const getMore = async () => {
    await axios
      .get(apiBaseUrl + "/more")
      .then((res) => {
        setMore(res.data.more);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Email Password not match!!");
      });
  };
  useEffect(() => {
    getMore();
  }, []);
  useEffect(() => {
    if (isRtl) {
      const p = document.getElementsByTagName("p");
      p[0].style.textAlign = "right";
    }
  }, [isRtl]);
  return (
    <>
      <Navigation home={false} isRtl={isRtl} />

      {more && (
        <div>
          <video
            width={window.innerWidth}
            height={window.innerHeight}
            autoPlay={true}
            controls={true}
            loop={true}
            style={{
              width: "100vw",
              height: "100vh",
              backgroundColor: "#000",
            }}
          >
            <source
              src={apiBaseAssets + more[lc("video", isRtl)]}
              type="video/mp4"
            />
          </video>

          <div style={{ padding: "2rem" }}>
            <ReactQuill
              ref={quillRef}
              style={{ textAlign: isRtl ? "right !important" : "left" }}
              value={more[lc("description", isRtl)]}
              readOnly={true}
              theme={"bubble"}
            />
          </div>
        </div>
      )}
      {/* </div>
      </header> */}
      <div id="footer" style={{ backgroundColor: "#000" }}>
        <div className="container text-center">
          <p>
            &copy; 2021 All Rights Reserved To PROCAST. Powerde By{" "}
            <a href="https://www.perla-tech.com" rel="nofollow">
              Perla Tech
            </a>
          </p>
        </div>
      </div>
    </>
  );
};
